//@flow

import env from '../../environment';
import {postCreator, putCreator} from '../../http';

export const endpoints = Object.freeze({
  BULK_DELETE: `${env.baseApiUrl}/im/admin/product/bulk/delete`,
  BULK_EDIT: `${env.baseApiUrl}/im/admin/product/bulk`,
});

export const bulkDeleteApi = postCreator(endpoints.BULK_DELETE);
export const bulkEditApi = putCreator(endpoints.BULK_EDIT);
